import BillingItemsDB from 'src/fb/billingItems-db';
import { auth as useAuthStore } from 'src/store/auth';
import { computed } from 'vue';

/** @type {import('../../application/ports/SessionDeliverySurfaces.port').HeldSessionRepository} */
export const heldSessionRepository = {
  async findHeldSessions(clinicId, sessionPlanDeclaration, holdReason) {
    const items = await new BillingItemsDB().readAll([
      ['clinicId', '==', clinicId],
      ['sessionPlanDeclaration', '==', sessionPlanDeclaration],
      ['holdReasons', 'array-contains', holdReason],
    ]);

    return items.map((item) => ({ sessionActivityId: item.sessionActivityId, serviceDate: item.serviceDate ?? null }));
  },
};

/**
 * The places and treatment services a delivery can name, as the delivery fields take them.
 * Bound lazily by the store; asking again once bound costs nothing.
 */
export function serviceDeliveryCatalogs() {
  const authStore = useAuthStore();

  // The store has already logged a failed bind, and an empty picker is how one should look here.
  authStore.ensurePlacesOfServiceBound().catch(() => {});
  authStore.ensureTreatmentServicesBound().catch(() => {});

  return {
    placesOfService: computed(() => (authStore.placesOfService ?? [])
      .map((placeOfService) => ({ id: placeOfService.id, name: placeOfService.placeOfServiceName }))),
    treatmentServices: computed(() => (authStore.treatmentServices ?? [])
      .map((treatmentService) => ({ id: treatmentService.id, name: treatmentService.serviceName }))),
    isLoading: computed(() => Boolean(authStore.isLoadingPlacesOfService)
      || Boolean(authStore.isLoadingTreatmentServices)),
  };
} // serviceDeliveryCatalogs()
